import React from 'react'
import { useContext } from 'react'
import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Typography,
    Box,
    useTheme,
    useMediaQuery
} from "@mui/material"
import UserContextP from "Interfaces/Context"

interface PropsInterface {
    order: any
    color: string
}

const TableProducts: React.FC<PropsInterface> = ({ order, color }) => {
    const context = useContext(UserContextP)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const priceProduct = (price: number, cantidad: number): number => Math.round((price * cantidad) * 100) / 100
    const products = order?.products ?? []

    return (
        <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ border: '1px solid rgba(0,0,0,0.12)', width: '100%', overflowX: 'auto' }}>
                <Box sx={{ p: 1, bgcolor: color, color: '#fff' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Productos</Typography>
                </Box>

                {isMobile ? (
                    <Box sx={{ p: 1 }}>
                        {products.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">No hay productos en esta orden.</Typography>
                        ) : (
                            products.map((item: any, index: number) => {
                                const line = priceProduct(item.price, item.cantidad)
                                const lineWithTax = Math.round(line * 1.13 * 100) / 100
                                return (
                                    <Paper key={index} variant="outlined" sx={{ p: 1, mb: 1 }}>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item xs={3}>
                                                <Box sx={{ textAlign: 'center' }}>
                                                    <Typography variant="subtitle2">{item.cantidad}x</Typography>
                                                    <Typography variant="caption" color="text.secondary">{item.id}</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" sx={{ whiteSpace: 'normal' }}>{item.ItemName}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ textAlign: 'right' }}>
                                                    <Typography variant="subtitle2">{(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + context.separatorMiles(lineWithTax)}</Typography>
                                                    <Typography variant="caption" color="text.secondary">con IVA</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                    <Typography variant="caption" color="text.secondary">Precio unitario: {(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + context.separatorMiles(item.price)} • Línea sin IVA: {(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + context.separatorMiles(line)}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                )
                            })
                        )}
                    </Box>
                ) : (
                    <Table size="small" aria-label="productos">
                        <TableHead>
                            <TableRow>
                                <TableCell>Cod.</TableCell>
                                <TableCell align="center">Cant.</TableCell>
                                <TableCell>Desc.</TableCell>
                                <TableCell align="right">Precio unitario<br />sin iva</TableCell>
                                <TableCell align="right">Precio de linea<br />sin iva</TableCell>
                                <TableCell align="right">Precio de linea<br />con iva</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <Typography variant="body2" color="text.secondary">No hay productos en esta orden.</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                products.map((item: any, index: number) => {
                                    const line = priceProduct(item.price, item.cantidad)
                                    const lineWithTax = Math.round(line * 1.13 * 100) / 100
                                    return (
                                        <TableRow key={index} hover>
                                            <TableCell component="th" scope="row" sx={{ width: 120 }}>{item.id}</TableCell>
                                            <TableCell align="center" sx={{ width: 80 }}>{item.cantidad}</TableCell>
                                            <TableCell sx={{ maxWidth: 420, whiteSpace: 'normal' }}>{item.ItemName}</TableCell>
                                                <TableCell align="right">{(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + context.separatorMiles(item.price)}</TableCell>
                                                <TableCell align="right">{(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + context.separatorMiles(line)}</TableCell>
                                                <TableCell align="right">{(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + context.separatorMiles(lineWithTax)}</TableCell>
                                        </TableRow>
                                    )
                                })
                            )}
                        </TableBody>
                    </Table>
                )}
            </TableContainer>
        </Grid>
    )
}

export default TableProducts